import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Restricted from '../Restricted/Restricted';
import { GTMsendEvent } from '../../utils/trackingGA4';
import { VehicleStateEnum } from '../../api';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { getUrl } from '../../utils';
import { RoleEnum } from '../../api';

const DetailsActionsDropdown = ({
	showModal,
	vehicleResponse,
	statoVeicolo,
	vehicleId,
	sendSelectActionToGA4,
	makeAvailable,
	extensionNum,
	wasActionDoneByCurrentUser,
	inEvidenza,
	isReoptionable,
	isActionForbidden,
	isSoldOverXDaysAgo,
}) => {
	const { userRole } = useAuth();
	const { t } = useTranslation();
	const navigate = useNavigate();

    return (
        <Restricted
            to={[
                RoleEnum.MASTER,
                RoleEnum.BACKOFFICE,
                RoleEnum.AREA_MANAGER,
                RoleEnum.SALES,
								RoleEnum.SALES_DEALER,
								RoleEnum.SALES_INTERNAL,
                RoleEnum.ADMIN,
            ]}
        >
            <Dropdown className="me-2 ms-1 align-text-bottom d-inline-block action-dropdown">

                {/* <Dropdown.Toggle
                as={forwardRef<any, DOMAttributes<any>>((props, ref) => (
                    <Btn ref={ref} {...props}>
                        Menu Azioni
                    </Btn>
                ))}
            ></Dropdown.Toggle> */}
                <Dropdown.Toggle className="btn m-0">{t('actions')}</Dropdown.Toggle>

                <Dropdown.Menu className="position-fixed">
                    <Restricted
                        to={[RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.ADMIN, RoleEnum.AREA_MANAGER]}
                    >
                        <Dropdown.Item
                            onClick={() => {
                                showModal('historyActions');
                                GTMsendEvent({
                                    event: 'CTA_storico',
                                    evtCat: 'storico',
                                    evtAct: 'click',
                                    evtLab: vehicleResponse.dati_veicolo.allestimento,
                                });
                            }}
                        >
                            {t('view_history')}
                        </Dropdown.Item>
                    </Restricted>

                    <Restricted to={[RoleEnum.MASTER, RoleEnum.ADMIN]}>
                        <Dropdown.Item
                            as={Link}
                            to={`/details/${vehicleId}/edit`}
                            disabled={userRole === RoleEnum.MASTER ? false : statoVeicolo === VehicleStateEnum.VENDUTO}
                            onClick={() =>
                                sendSelectActionToGA4('modifica_dati_veicolo')
                            }
                        >
                            {t('modify_vehicle_data')}
                        </Dropdown.Item>
                    </Restricted>

					<Restricted to={[RoleEnum.MASTER, RoleEnum.ADMIN]}>
						<OverlayTrigger
							placement="left"
							overlay={
								isSoldOverXDaysAgo ? (
									<Tooltip>
										{t('make_available_disabled_sold_over_x_days', {
											defaultValue:
												'Non è più possibile rendere disponibile un veicolo venduto da più di {{gg}} giorni',
												gg: 180
										})}
									</Tooltip>
								) : (
									<span />
								)
							}
						>
							<span className="d-block">
								<Dropdown.Item
									as="button"
									onClick={() => {
										makeAvailable();
										sendSelectActionToGA4('rendi_veicolo_disponibile');
									}}
									disabled={
										statoVeicolo !== VehicleStateEnum.VENDUTO ||
										isSoldOverXDaysAgo
									}
								>
									{t('make_it_available')}
								</Dropdown.Item>
							</span>
						</OverlayTrigger>
					</Restricted>

					<Restricted to={[RoleEnum.MASTER, RoleEnum.ADMIN]}>
						<Dropdown.Item
							as={Link}
							to={`/details/${vehicleId}/clone`}
							onClick={() => sendSelectActionToGA4('duplica_veicolo')}
						>
							{t('duplicate_vehicle')}
						</Dropdown.Item>
					</Restricted>

					{/* <MarketFilter markets={[Markets.it]}> */}
					<>
						<Restricted
							to={[
								RoleEnum.MASTER,
								RoleEnum.ADMIN,
								RoleEnum.BACKOFFICE,
								RoleEnum.AREA_MANAGER,
								RoleEnum.SALES,
								RoleEnum.SALES_DEALER,
								RoleEnum.SALES_INTERNAL,
							]}
						>
							<Dropdown.Item
								as="button"
								onClick={() => {
									sendSelectActionToGA4('inserisci_opzione');
									navigate(
										getUrl('/opportunities/new', {
											from: 'vehicle',
											vehicle_id: vehicleResponse.id,
											action: 'create_option',
										})
									);
								}}
								disabled={
									statoVeicolo !== VehicleStateEnum.DISPONIBILE ||
									!isReoptionable
								}
							>
								{t('insert_option')}
							</Dropdown.Item>
							<Dropdown.Item
								as="button"
								onClick={() => {
									showModal('renewOption');
									sendSelectActionToGA4('rinnova_opzione');
								}}
								disabled={
									statoVeicolo !== VehicleStateEnum.OPZIONATO ||
									extensionNum > 0 ||
									(userRole !== RoleEnum.MASTER &&
										!wasActionDoneByCurrentUser(
											VehicleStateEnum.OPZIONATO,
											vehicleResponse.stato_corrente
										))
								}
							>
								{t('renew_option')}
							</Dropdown.Item>
							<Dropdown.Item
								as="button"
								onClick={() => {
									showModal('deleteOptions');
									sendSelectActionToGA4('cancella_opzione');
								}}
								disabled={
									statoVeicolo !== VehicleStateEnum.OPZIONATO ||
									(userRole !== RoleEnum.MASTER &&
										!wasActionDoneByCurrentUser(
											VehicleStateEnum.OPZIONATO,
											vehicleResponse.stato_corrente
										))
								}
							>
								{t('delete_option')}
							</Dropdown.Item>
						</Restricted>

						<Restricted
							to={[RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.ADMIN]}
						>
							<Dropdown.Item
								as="button"
								onClick={() => {
									showModal('hideOption');
									sendSelectActionToGA4('oscura_veicolo');
								}}
								disabled={statoVeicolo !== VehicleStateEnum.DISPONIBILE}
							>
								{t('hide_vehicle')}
							</Dropdown.Item>
						</Restricted>
					</>
					{/* </MarketFilter> */}

					<Restricted
						to={[RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.ADMIN]}
					>
						<Dropdown.Item
							as="button"
							onClick={() => {
								showModal('hideRenew');
								sendSelectActionToGA4('rinnova_oscuramento');
							}}
							disabled={
								statoVeicolo !== VehicleStateEnum.OSCURATO ||
								!wasActionDoneByCurrentUser(
									VehicleStateEnum.OSCURATO,
									vehicleResponse.stato_corrente
								)
							}
						>
							{t('renew_hide')}
						</Dropdown.Item>
					</Restricted>

					<Restricted
						to={[RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.ADMIN]}
					>
						<Dropdown.Item
							as="button"
							onClick={() => {
								showModal('releaseOption');
								sendSelectActionToGA4('rimuovi_oscuramento');
							}}
							disabled={
								statoVeicolo !== VehicleStateEnum.OSCURATO ||
								((userRole !== RoleEnum.MASTER ||
									userRole !== RoleEnum.ADMIN) &&
									!wasActionDoneByCurrentUser(
										VehicleStateEnum.OSCURATO,
										vehicleResponse.stato_corrente
									))
							}
						>
							{t('delete_hide')}
						</Dropdown.Item>
					</Restricted>

					{/* <MarketFilter markets={[Markets.it]}> */}
					<Restricted
						to={[RoleEnum.BACKOFFICE, RoleEnum.MASTER, RoleEnum.ADMIN]}
					>
						<Dropdown.Item
							as="button"
							onClick={() => {
								sendSelectActionToGA4('conferma_vendita');
								navigate(
									getUrl('/opportunities/new', {
										from: 'vehicle',
										vehicle_id: vehicleResponse.id,
										action: 'confirm_sell',
									})
								);
							}}
							disabled={
								statoVeicolo === VehicleStateEnum.VENDUTO || isActionForbidden!
							}
						>
							{t('confirm_sale')}
						</Dropdown.Item>
					</Restricted>
					{/* </MarketFilter> */}

					<Dropdown.Item
						as="button"
						onClick={() => showModal('downloadPdf')}
						disabled={!vehicleResponse.lista_offerte?.length}
					>
						{t('download_pdf')}
					</Dropdown.Item>

					<Restricted to={[RoleEnum.MASTER, RoleEnum.ADMIN]}>
						<Dropdown.Item
							as="button"
							onClick={() => {
								showModal('deleteVehicle');
								sendSelectActionToGA4('elimina_veicolo');
							}}
							disabled={statoVeicolo !== VehicleStateEnum.DISPONIBILE}
						>
							{t('delete')}
						</Dropdown.Item>
					</Restricted>

					{/* toggle in evidenza */}
					<Restricted to={[RoleEnum.MASTER, RoleEnum.ADMIN]}>
						{![VehicleStateEnum.OSCURATO, VehicleStateEnum.VENDUTO].includes(
							statoVeicolo!
						) ? (
							<Dropdown.Item
								as="button"
								onClick={() => {
									showModal('toggleInEvidenza');
									sendSelectActionToGA4(
										inEvidenza ? 'rimuovi_in_evidenza' : 'metti_in_evidenza'
									);
								}}
							>
								{inEvidenza ? t('remove_highlight') : t('give_highlight')}
							</Dropdown.Item>
						) : (
							''
						)}
					</Restricted>
				</Dropdown.Menu>
			</Dropdown>
		</Restricted>
	);
};

export default DetailsActionsDropdown;
